// 그래프 API
import axiosInstance from './axiosInstance';

// 포트폴리오 구성 (섹터별 / 계좌별)
export const fetchPortfolio = async (accountName, includeInterest) => {
  const params = { include_interest: includeInterest ?? false };
  if (accountName) params.account_name = accountName;
  const res = await axiosInstance.get('/graph/portfolio', { params });
  return res.data;
};

// 포트폴리오 상세 (도넛 더블클릭 팝업용)
export const fetchPortfolioDetail = async (accountName, includeInterest, segmentType, segmentName) => {
  const params = {
    include_interest: includeInterest ?? false,
    segment_type: segmentType,
    segment_name: segmentName,
  };
  if (accountName) params.account_name = accountName;
  const res = await axiosInstance.get('/graph/portfolio/detail', { params });
  return res.data;
};

// 종목별 수익률 (avg_buy_price, total_qty, db_price 포함 — 실시간 재계산용)
// DEPOSIT/CMA 종목은 서버에서 항상 제외
export const fetchProfitRate = async (accountName) => {
  const params = {};
  if (accountName) params.account_name = accountName;
  const res = await axiosInstance.get('/graph/profit-rate', { params });
  return res.data;
};

// 현금흐름 (월별 분배금 + 매도손익)
export const fetchCashflow = async (accountName, months = 13) => {
  const params = { months };
  if (accountName) params.account_name = accountName;
  const res = await axiosInstance.get('/graph/cashflow', { params });
  return res.data;
};

// 목표비율 vs 현재비율
export const fetchPlanRatio = async (accountName, includeInterest) => {
  const params = { include_interest: includeInterest ?? false };
  if (accountName) params.account_name = accountName;
  const res = await axiosInstance.get('/graph/plan-ratio', { params });
  return res.data;
};
